import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import FieldCombo from '../combos/FieldCombo';
import { Checkbox } from 'primereact/checkbox';
import * as XLSX from "xlsx";        
import FaDate from '../shared/FaDate';
import { Col, Form, Row } from 'react-bootstrap';
import DisorderTypeCombo from '../combos/DisorderTypeCombo';
import StudentCombo from '../combos/StudentCombo';
import ShowVideo from '../shared/ShowVideo';

export default function SchoolDisiplineNotebook(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

  
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({length:5});

  const [currentId, setCurrentId] = useState("");
  const [date, setDate] = useState(0);
  const [newDate, setNewDate] = useState(0);
  const [student, setStudent] = useState(null);
  const [disorderType, setDisorderType] = useState(null);
  const [comment, setComment] = useState("");
  const [effectScore, setEffectScore] = useState("");
  
  const [fromDate, setFromDate] = useState(0);
  const [newFromDate, setNewFromDate] = useState(0);
  
  const [toDate, setToDate] = useState(0);
  const [newToDate, setNewToDate] = useState(0);
  
  const [searchText, setSearchText] = useState("");
  const [searchDisorderType, setSearchDisorderType] = useState(null);
  
  useEffect(() => {

    searchItems();
  }, []);
  const searchItems = function(){
    setLoading(true);
    var doId = "";
    if(searchDisorderType != null)
      if(searchDisorderType.id) doId = searchDisorderType.id;

    var params = {login:util.getTrustedUser(), lastIndex:0, pageSize:0, 
      searchText:searchText, 
      disOrderTypeId:doId, 
      fromDate:newFromDate,
      toDate:newToDate,
    };
    var url = config.Server+`/school/disorder/list`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("response is>", response);
                
                setItems(response);
                setFilterItems(response);
                
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });
  }
  const addNewItem = function(){
    setDate(newDate);
    //setNewDate(0);
    setCurrentId("");
    setStudent(null);
    setEditFormVisible(true);
  }
  const onRowEditClick = function(row) {
    setCurrentId(row.id);
    setStudent(row.student);
    setDate(row.issueDate);
    setDisorderType(row.disorderType);
    setComment(row.comment);
    setEffectScore(String(row.effectScore));
    setEditFormVisible(true);        
  }
  const onRowDeleteClick = function(row) {
    setCurrentId(row.id);
    setConfirmDeleteVisible(true);
  }

  const closeNewDialog = function(){
    setEditFormVisible(false);
  }
  const closeEditDialog = function(){
    setEditFormVisible(false);
  }
  const deleteItem = function(){
    setDeleting(true);
    var id = currentId;
    var params = {login:util.getTrustedUser(), id:currentId};
    var url = config.Server+`/school/disorder/delete`;
      axios
          .post(url, params )
          .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                var tmp = [...items];
                for(var i=0;i<tmp.length;i++){
                  if(tmp[i].id === id){
                    tmp.splice(i, 1);
                    break;
                  }
                }
                setCurrentId("");
                setItems(tmp);
                setFilterItems(tmp);

                setDeleting(false);
                setConfirmDeleteVisible(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setDeleting(false);
            }
          })
          .catch(error => {
            setDeleting(false);
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
          });
  }
  const onDeleteConfirm_Accept = function(){
    deleteItem();
  }
  const onDeleteConfirm_Reject = function(){
      if(deleting) return;
      setConfirmDeleteVisible(false);
  }

  const checkDataEntry = function(){
    if(newDate<=0){
      setErorVisible(true);
      setErrorMessage("تاریخ رفتار را مشخص نمائید");
      return false;
    }
    if(student == null){
      setErorVisible(true);
      setErrorMessage("دانش آموز را مشخص نمائید");
      return false;

    }
    if(!student.id){
      setErorVisible(true);
      setErrorMessage("دانش آموز را مشخص نمائید");
      return false;

    }
    if(disorderType == null){
      setErorVisible(true);
      setErrorMessage("نوع رفتار را مشخص نمائید");
      return false;

    }
    if(!disorderType.id){
      setErorVisible(true);
      setErrorMessage("نوع رفتار را مشخص نمائید");
      return false;

    }
    if(effectScore == ""){
      setErorVisible(true);
      setErrorMessage("نمزه منفی را مشخص نمائید");
      return false;
    }
    return true;
  }
  const saveItem = function(){
    if(!checkDataEntry()) return;
      setSaving(true);
      var params = {login:util.getTrustedUser(), id:currentId, studentId:student.id, disorderTypeId:disorderType.id, effectScore:parseFloat(effectScore), comment:comment, issueDate:newDate};
      var url = config.Server+`/school/disorder/save`;
      console.log("params to save is>", params);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(currentId === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === currentId){
                        tmp[i] = {...response}
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setEditFormVisible(false);

              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

  }
  const editDialogFooter = function(){
      return (
          <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
      )
  }
  const onInputChange = function(e, name){
      var val = '';
      val = (e.target && e.target.value) || '';
      if(name === "searchText") setSearchText(val);
      else if(name === "comment") setComment(val);
      else if(name === "effectScore") setEffectScore(val);
  }

  const onComboChange = function(name, value){
    if(name === "searchDisorderType"){
      setSearchDisorderType(value);
    }
    else if(name === "disorderType"){
      setDisorderType(value);
    }
    return
  }
  const setRowActions = function(row) {
      return (
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </Row>
      );
  }
  const showScore = function(row) {
      return (
            <label style={{color:row.disorderType.zarib==1?"rgba(20, 151, 20, 1)":"#F00"}}>{row.effectScore}</label>
      );
  }
  return(      
    <> 
    <ShowVideo videoId="disipline_book" top={65} md={6} />  
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>دفتر انضباط</div>
      <div className="" style={{ width:"calc(100% - 0px)"}}>
        <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
            <Row>
              <Col md={3} style={{height:"75px", paddingTop:"30px"}}>
                <FloatLabel>
                    <InputText value={searchText} onChange={(e)=>{onInputChange(e, "searchText")}} id="searchText" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", padding:'10px'}} />
                    <label htmlFor="username">جستجو</label>
                </FloatLabel>
              </Col>
              <Col md={3}>
                <DisorderTypeCombo returnFullItem={true} value={searchDisorderType} onChange={(val) => onComboChange('searchDisorderType', val)} loadSchoolEffectScore={true}/>
              </Col>
              <Col sd={2} style={{paddingTop:"11px"}}>
                از تاریخ:
                <br/>
                <FaDate value={fromDate} onChange={(val)=>setNewFromDate(val)} />
              </Col>
              <Col sd={2} style={{paddingTop:"11px"}}>
                تا تاریخ:
                <br/>
                <FaDate value={toDate} onChange={(val)=>setNewToDate(val)} />
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{float:'right', margin:'10px', display:'block', direction:"ltr", textAlign:"right"}}>
                  <Button label="جستجو" icon="pi pi-search" onClick={()=>searchItems()} severity="primary" iconPos="right" />
                </div>
                
              </Col>
            </Row>
        </div>
      </div>
      <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>
        {
          loading?
                  <DataTable value={LoadingRows}  className="p-datatable-striped">
                      <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                      <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                  </DataTable>
          :
            <>
            <div className='col-12' style={{overflowX:"hidden"}}>
              <Row style={{}}>
                <Col md={2}>
                  <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right", margin:"10px" }}>             
                    <Button label="افزودن به لیست" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />
                  </div>                
                </Col>
              </Row>
              <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" 
              currentPageReportTemplate="{first} تا {last} از {totalRecords}"
              dataKey="id" selection={null}  onSelectionChange={(e) => {setCurrentId(e.value.id)}}>
                      <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                      <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                      {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                      <Column field="issueDate" body={(row) => util.SeperateDate(row.issueDate)} header={"تاریخ"} sortable className="list-cell-text-align"></Column>
                      <Column field="student.nationalId" body={(row) => row.student.nationalId} header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                      <Column field="student.firstname" body={(row) => row.student.firstname} header={"نام"} sortable className="list-cell-text-align"></Column>
                      <Column field="student.lastname" body={(row) => row.student.lastname} header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                      <Column field="disorderType.title" body={(row) => row.disorderType.title} header={"نوع رفتار"} sortable className="list-cell-text-align"></Column>
                      <Column body={(row) => showScore(row)} header={"نمره موثر"} className="list-cell-text-align"></Column>
                      <Column body={(row) => setRowActions(row)} exportable={false} style={{ width:"100px" }}></Column>
              </DataTable>
            </div>
            </>
        }           
      </div>
      {
      editFormVisible?
      <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت رفتار" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
        <table style={{marginTop:"10px", width:"100%"}}>
          <tbody>
            <tr>
              <td style={{width:"100px"}}>تاریخ </td>
            </tr>
            <tr>
              <td style={{width:"140px"}}><FaDate value={date} onChange={(val)=>setNewDate(val)} /></td>
            </tr>
            <tr>
              <td style={{paddingTop:"10px"}}>
                <StudentCombo value={student} onChange={(value)=>{ setStudent(value.itemValue)}}  returnFullItem={true}/>
              </td>
            </tr>
            <tr>
              <td style={{paddingTop:"10px"}}>
                <DisorderTypeCombo loadSchoolEffectScore={true} value={disorderType} onChange={(value)=>{setEffectScore(String(value.effectScore)); setDisorderType(value)}} returnFullItem={true}/>
              </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
            <tr>
              <td style={{padding:"1px"}}>
                <FloatLabel>
                    <InputText value={comment} onChange={(e)=>{onInputChange(e, "comment")}}keyfilter="" maxLength={200} className="p-inputtext-lg" style={{width:"100%", textAlign:"right", direction:"rtl"}} />
                    <label htmlFor="username">شرح</label>
                </FloatLabel>
              </td>
            </tr>
            <tr><td>&nbsp;</td></tr>
            <tr>
              <td style={{padding:"1px"}}>
                <FloatLabel>
                    <InputText value={effectScore} onChange={(e)=>{onInputChange(e, "effectScore")}}keyfilter="num" maxLength={5} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                    <label htmlFor="username">نمره موثر</label>
                </FloatLabel>
              </td>
            </tr>
          </tbody>
        </table>

      </Dialog>
      :
      <></>
      }

    <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
    <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
    </>  
  );
}
